// src/context/AuthContext.jsx
import React, { createContext, useState, useEffect, useContext } from 'react';
import { 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  signOut, 
  onAuthStateChanged,
  signInWithPopup,
  GoogleAuthProvider
} from 'firebase/auth';
import { ref, set, get } from 'firebase/database';
import { auth, googleProvider, database, ADMIN_EMAILS } from '../firebase/config';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  
  function register(email, password) {
    return createUserWithEmailAndPassword(auth, email, password);
  }

  // Connexion avec email/password
  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  // Connexion avec Google
  async function signInWithGoogle() {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      
      // Vérifier si l'utilisateur existe dans la base de données
      const userRef = ref(database, `utilisateurs/${user.uid}`);
      const snapshot = await get(userRef);
      
      // Si l'utilisateur n'existe pas, le créer
      if (!snapshot.exists()) {
        // Extraire le prénom et nom depuis l'affichage Google
        const displayName = user.displayName || '';
        const nameParts = displayName.split(' ');
        const prenom = nameParts[0] || '';
        const nom = nameParts.slice(1).join(' ') || '';
        
        await set(userRef, {
          prenom,
          nom,
          nomComplet: displayName,
          email: user.email,
          telephone: user.phoneNumber || '',
          photoURL: user.photoURL || '',
          dateInscription: new Date().toISOString(),
          role: ADMIN_EMAILS.includes(user.email) ? 'admin' : 'client',
          provider: 'google'
        });
      }
      
      return result;
    } catch (error) {
      console.error('Erreur Google:', error);
      throw error;
    }
  }

  // Déconnexion
  function logout() {
    return signOut(auth);
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setIsAdmin(user ? ADMIN_EMAILS.includes(user.email) : false);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    isAdmin,
    register,
    login,
    signInWithGoogle,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}